import type { SelectProps } from '@risk-smart/themed-cloudscape-components/select';
import _ from 'lodash';
import type { FC } from 'react';
import { MultiSelect } from 'src/components/form/controlled-multiselect/ControlledMultiselect';
import { useTagOptions } from 'src/components/form/tag-selector/useTagOptions';

import type { CustomAttributeProps } from './CustomAttributeProps';

const getSelectedOptions = (
  options: (SelectProps.Option | SelectProps.OptionGroup)[],
  value: string[] | null
) => {
  const selectedOptions: SelectProps.Option[] = [];
  for (const option of options) {
    if (option.value && value?.includes(option.value)) {
      selectedOptions.push(option);
    }
    if ('options' in option) {
      for (const subOption of option.options) {
        if (subOption.value && value?.includes(subOption.value)) {
          selectedOptions.push(subOption);
        }
      }
    }
  }

  return selectedOptions;
};

export const CustomAttributeTagsMultiSelect: FC<
  CustomAttributeProps<null | string[]>
> = ({ label, onChange, value, disabled, error, description }) => {
  const { tags, optionItems: options, statusType } = useTagOptions();

  return (
    <MultiSelect
      statusType={statusType}
      testId={label}
      description={description}
      label={label}
      onChange={(e) =>
        onChange(
          e.detail.selectedOptions
            .map((o) => o.value)
            .filter((v): v is string => !!v)
        )
      }
      expandToViewport
      options={options}
      disabled={disabled}
      placeholder={'Select'}
      errorMessage={error}
      tokenSection={<></>}
      selectedOptions={getSelectedOptions(options, value)}
      renderTokens={false}
      previewChangesFormatter={(val: string[] | null | undefined) => {
        if (Array.isArray(val)) {
          return val
            .map((v) => tags.find((t) => t.TagTypeId === v)?.Name ?? v)
            .join(', ');
        }

        return '-';
      }}
      hasFieldChanged={(
        val:
          | {
              from: string[] | null | undefined;
              to: string[] | null | undefined;
            }
          | null
          | undefined
      ) => {
        if (val === undefined || val === null) {
          return false;
        }
        const from = [...(val.from ?? [])].sort();
        const to = [...(val.to ?? [])].sort();

        return !_.isEqual(from, to);
      }}
    />
  );
};
